import React from 'react';
import {
  Avatar,
  Badge,
} from '@material-ui/core';

import { Lock } from '@material-ui/icons';

import { withStyles } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

const EditableStyledBadge = withStyles((theme) => ({
  badge: {
    // Per a mostrar-ho amb la mida del dot per defecte comentar width, height i borderRadius
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);

const SmallAvatar = withStyles((theme) => ({
  root: {
    width: 30,
    height: 30,
    border: `2px solid ${theme.palette.background.paper}`,
    // backgroundColor: 'white',
  },
}))(Avatar);

export default function UserScheduleStatusIcon({ remainingDays, status, userScheduleOwner }) {
  const ownerColorAndOpacity = (usOwner, usStatus) => {
    let color = 'default';
    switch (usOwner) {
      case 'patient':
        color = '#8ec63f';
        break;
      case 'clinic':
        color = '#00adee';
        break;
      case 'otherClinic':
        color = '#757575';
        break;
    }
    // Taula de correspondencia de la opacitat (canal alpha) entre % i hexadecimal:
    // https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4
    let alpha = 'ff'; // 100%
    if (usStatus === 'notOpened') alpha = '80'; // 50%
    /* switch (usStatus) {
      case 'opened': // Està en període de poder ser contestat
        alpha = 'ff'; // 100%
        break;
      case 'editable': // Està en període de poder ser contestat i ja s'ha començat a contestar
        alpha = '99'; // 60%
        break;
      case 'notOpened': // Encara no es pot contestar
        alpha = '4D'; // 30%
        break;
    } */
    return color + alpha;
  };

  const customAvatar = () => {
    return (
      <Avatar
        style={{
          backgroundColor: ownerColorAndOpacity(userScheduleOwner, status),
          color: 'white',
        }}
        variant={userScheduleOwner === 'patient' ? 'circle' : 'rounded'}
      >
        {remainingDays}
      </Avatar>
    );
  };

  // Formulari OBERT: es pot començar a respondre
  if (status === 'opened') {
    return (
      customAvatar()
    );
  }

  // Formulari EDITABLE: ja s'ha començat a emplenar:
  if (status === 'editable') {
    return (
      <EditableStyledBadge
        overlap='circle'
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        variant='dot'
      >
        {customAvatar()}
      </EditableStyledBadge>
    );
  }

  // Formulari NO OBERT: encara no es pot començar a respondre
  return (
    <Badge
      overlap='circle'
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      badgeContent={<SmallAvatar><Lock fontSize='small' style={{ color: '#757575' }} /></SmallAvatar>}
    >
      {customAvatar()}
    </Badge>
  );
}

// Indica i controla els props que se han de passar al component
UserScheduleStatusIcon.propTypes = {
  remainingDays: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  userScheduleOwner: PropTypes.string.isRequired,
};
